import { InputType } from 'config'

export const defaultInputs = (): Record<string, Record<string, InputType>> => {
  return {
    propertyExpense: {
      name: {
        inputType: 'text',
        title: 'Vendor Name',
      },
      address: {
        inputType: 'map',
        title: 'Vendor Address',
      },
      phone: {
        inputType: 'text',
        type: 'phone',
        title: 'Vendor Phone Number',
      },
      website: {
        inputType: 'text',
        type: 'url',
        title: 'Vendor Website',
      },
      email: {
        inputType: 'text',
        type: 'email',
        title: 'Vendor Email Address',
      },
      notes: {
        inputType: 'textarea',
        title: 'Notes',
        span: 'full',
      },
    },
    taxAuthority: {
      name: {
        inputType: 'text',
        title: 'Name',
      },
      address: {
        inputType: 'map',
        title: 'Address',
      },
      phone: {
        inputType: 'text',
        type: 'phone',
        title: 'Phone Number',
      },
      website: {
        inputType: 'text',
        type: 'url',
        title: 'Website',
      },
      email: {
        inputType: 'text',
        type: 'email',
        title: 'Email Address',
      },
      amountDue: {
        inputType: 'text',
        type: 'thousandSep',
        title: 'Amount Due',
        prefix: '$',
      },
      dueDate: {
        inputType: 'text',
        type: 'date',
        title: 'Due Date',
      },
      notes: {
        inputType: 'textarea',
        title: 'Notes',
        span: 'full',
      },
    },
    insuranceCompany: {
      name: {
        inputType: 'text',
        title: 'Name',
      },
      address: {
        inputType: 'map',
        title: 'Address',
      },
      phone: {
        inputType: 'text',
        type: 'phone',
        title: 'Phone Number',
      },
      website: {
        inputType: 'text',
        type: 'url',
        title: 'Website',
      },
      email: {
        inputType: 'text',
        type: 'email',
        title: 'Email Address',
      },
      amountDue: {
        inputType: 'text',
        type: 'thousandSep',
        title: 'Amount Due',
        prefix: '$',
      },
      dueDate: {
        inputType: 'text',
        type: 'date',
        title: 'Due Date',
      },
      notes: {
        inputType: 'textarea',
        title: 'Notes',
        span: 'full',
      },
    },
  }
}

export const PropertyProfileUnderwritingKeys = [
  'CurrentSQFT',
  'AfterRehadSQFT',
  'BedroomCount',
  'BathroomCount',
  'LotSize',
  'YearBuilt',
]
